(function () {

    'use strict';

    class GeneralFormDetailCtrl {
        constructor($transition$, $state, $stateParams, $element, system, formsService, moment) {
            this.state = $state;
            this.element = $element;
            this.formsService = formsService;
            this.dateFormat = system['date_format'].js;
            this.currentForm = _.get($transition$.params('to'), 'form');
            this.currentTemplate = _.get($transition$.params('to'), 'template');
            this.moment = moment;

            this.prePrint = this.prePrint.bind(this);
            this.showFileManager = false;
        }

        static get $inject() {
            return ["$transition$", "$state", "$stateParams", "$element", "system", "formsService", "moment"];
        }

        $onInit() {
            this.formsService.editFormSubject.next(this.currentForm);
            if (this.currentForm) {
                this.formsService.getGeneralForm(this.currentForm).then(data => {
                    this.formTemplate = data;
                });
            } else {
                this.formTemplate = {
                    template: null,
                    date: this.moment().format(this.dateFormat)
                };
                this.formsService.getFormsTemplates(this.currentTemplate).then(data => {
                    this.formTemplate.template = _.cloneDeep(data)
                })

            }
        }

        saveForm() {
            return this.formsService.saveGeneralForm(this.formTemplate)
                .then(data => {
                    this.formTemplate = data;
                    this.formsService.newFormSubject.next(data);
                    this.state.go("app.forms.detail", {form: data.id}, {inherit: true}).then(_.noop);
                });
        }

        deleteItem() {
            this.formsService.deleteGeneralForm(this.formTemplate.id).then(_.noop);
        }

        prePrint() {
            return this.saveForm(this.formTemplate);
        }

        checkChoice(f, o) {
            return _.includes(f.value, o);
        }

        addChoice(f, o, idx) {
            if (_.includes(f.value, o)) {
                f.value.splice(idx, 1)
            } else {
                f.value = f.value || [];
                f.value.push(o);
            }
        }

        validate() {
            this.formTemplate.is_validated = true;

            return this.saveForm(this.formTemplate);
        }

        toggleFileManager() {
            this.showFileManager = !this.showFileManager;
        }
    }

    module.exports = GeneralFormDetailCtrl;

})();
